/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerCallLogsService = {

  async saveCustomerCallLog(payload) {
    var url = "api/Save_CallLog";

    return await ApiService.post(url, payload, "String");

  },

  async getByCustomerCallLogHeader(code) {
    const requestScreenData = {
      url: "api/CallLogHeader",
      top: "1",
      filter: `RecordId eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByCustomerCallLog(params) {
    const requestScreenData = {
      url: "api/CallLog",
      top: "1",
      filter: `RecordId eq ${params.filter}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getCallLogNoteByCallLog(code) {
    const requestScreenData = {
      url: "api/CallLogNote",
      filter: `CallLogHeaderRecordID eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getCallLogNoteImagesMetaByCallLogNote(code) {
    const requestScreenData = {
      url: "api/CallLogNoteImagesMeta",
      filter: `CallLogNoteRecordID eq ${code}`,// and SizeType eq 'thumb'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CustomerCallLogsService };
